import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const StartNegotiationDialog = ({ target, onClose, onDone }) => {
  const { getAuthHeader } = useAuth();
  const [roles, setRoles] = useState({ lab_manager: false, operations_manager: true, finance: false });
  const [submitting, setSubmitting] = useState(false);

  const handleStart = async () => {
    const selected = Object.keys(roles).filter((r) => roles[r]);
    if (selected.length === 0) {
      toast.error('Select at least one negotiator');
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/quotations/${target.id}/start-negotiation`,
        { negotiators: selected }, { headers: getAuthHeader() });
      toast.success('Negotiation started — participants notified');
      onDone();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to start negotiation');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={!!target} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Start Negotiation — {target.vendor_name}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-sm text-text-secondary">
            Current quoted price: <span className="font-semibold text-text-primary">₹{target.price.toFixed(2)}</span>.
            Select who will negotiate with the vendor — any one, two, or all three.
          </p>
          <div className="space-y-3">
            {[
              { key: 'lab_manager', label: 'Lab Manager' },
              { key: 'operations_manager', label: 'Operations Manager' },
              { key: 'finance', label: 'Finance' },
            ].map(({ key, label }) => (
              <label key={key} className="flex items-center gap-3 p-3 border border-border-default rounded cursor-pointer hover:bg-surface transition-colors">
                <Checkbox
                  checked={roles[key]}
                  onCheckedChange={(checked) => setRoles({ ...roles, [key]: !!checked })}
                  data-testid={`negotiator-checkbox-${key}`}
                />
                <span className="text-text-primary font-medium">{label}</span>
              </label>
            ))}
          </div>
          <Button
            className="w-full bg-accent-brand hover:bg-accent-brand-hover text-white"
            onClick={handleStart}
            disabled={submitting}
            data-testid="confirm-start-negotiation-button"
          >
            {submitting ? 'Starting...' : 'Start Negotiation & Notify Team'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default StartNegotiationDialog;
